import { Injectable } from '@angular/core';
import { UserHttpService } from '../../../user/services/user-http.service';

@Injectable({
    providedIn: 'root'
})
export class PingService {

    constructor(private httpService: UserHttpService) {
    }

    public ping() {
        return this.httpService.get('account/ping');
    }
}
